import { Button, DialogActions, DialogContent } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { withSnackbar } from 'notistack';
import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { LoadingButton, RegularDialog } from '../../components';
import { api } from 'utils';
import validate from './validations';

const mapStateToProps = null;

const mapDispatch = ({ auth }) => ({
    logout: () => auth.logout(),
});

const reduxConnector = connect(mapStateToProps, mapDispatch);

function UserForm(props) {
    const {
        loading, open, logout, onToggleFormClick, enqueueSnackbar,
    } = props;

    return (
        <RegularDialog
            title="Update Profile"
            open={open}
            onClose={onToggleFormClick}
        >
            <Formik
                initialValues={{
                    old_password: '',
                    new_password: '',
                    new_password_confirmation: '',
                }}
                validate={validate}
                onSubmit={(values, { setSubmitting }) => {
                    api.post('account', values)
                        .then(({ errors }) => {
                            if (errors) {
                                return enqueueSnackbar(errors.message, { variant: 'error' });
                            }

                            logout();
                            onToggleFormClick();
                            return enqueueSnackbar('Update success. You\'ll be logout', { variant: 'success' });
                        })
                        .finally(() => setSubmitting(false));
                }}
                component={({ isSubmitting }) => {
                    const inputProps = {
                        required: true,
                        fullWidth: true,
                        type: 'password',
                        margin: 'normal',
                        component: TextField,
                        variant: 'filled',
                    };
                    return (
                        <Form>
                            <DialogContent>
                                <Field
                                    {...inputProps}
                                    label="Old Password"
                                    name="old_password"
                                />

                                <Field
                                    {...inputProps}
                                    label="New Password"
                                    name="new_password"
                                />

                                <Field
                                    {...inputProps}
                                    label="Password Confirmation"
                                    name="new_password_confirmation"
                                />
                            </DialogContent>

                            <DialogActions>
                                <Button
                                    type="button"
                                    color="default"
                                    disabled={loading}
                                    onClick={onToggleFormClick}
                                >
                                    Cancel
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    loading={isSubmitting}
                                >
                                    Save
                                </LoadingButton>
                            </DialogActions>
                        </Form>
                    );
                }}
            />
        </RegularDialog>
    );
}

export default compose(
    withSnackbar,
    reduxConnector,
)(UserForm);
